import {type BeginnerModeActionState} from '@colonist/game-state-types'
import {type StateCreator} from 'zustand'
import {type BeginnerHintFormat} from '@colonist/game-base-types'
import {type BeginnerHintType, GAME_ACTION_TO_BEGINNER_HINT_TYPE} from '../../core/UIGameBeginnerHint/utils.ts'

export interface GameBeginnerHintSlice {
    gameBeginnerHint: {
        beginnerHintType: BeginnerHintType | undefined
        setBeginnerHintType: (beginnerHintType: BeginnerHintType | undefined) => void
        beginnerHintData: BeginnerHintFormat | undefined
        setBeginnerHintData: (beginnerHintData: BeginnerHintFormat | undefined) => void
        beginnerActionState: BeginnerModeActionState | undefined
        setBeginnerActionState: (actionState: BeginnerModeActionState | undefined) => void
    }
}

export const createGameBeginnerHintSlice = (): StateCreator<GameBeginnerHintSlice> => (set, get) => ({
    gameBeginnerHint: {
        beginnerHintType: undefined,
        setBeginnerHintType: (beginnerHintType: BeginnerHintType | undefined) => set({
            gameBeginnerHint: {
                ...get().gameBeginnerHint,
                beginnerHintType: beginnerHintType,
            },
        }),
        beginnerHintData: undefined,
        setBeginnerHintData: (beginnerHintData: BeginnerHintFormat | undefined) => {
            const beginnerHintType = beginnerHintData ? GAME_ACTION_TO_BEGINNER_HINT_TYPE[beginnerHintData?.type] : null
            if(beginnerHintType != null) {
                set({
                    gameBeginnerHint: {
                        ...get().gameBeginnerHint,
                        beginnerHintType: beginnerHintType,
                    },
                })
            }
            set({
                gameBeginnerHint: {
                    ...get().gameBeginnerHint,
                    beginnerHintData: beginnerHintData,
                },
            })
        },
        beginnerActionState: undefined,
        setBeginnerActionState: (actionState: BeginnerModeActionState | undefined) => set({
            gameBeginnerHint: {
                ...get().gameBeginnerHint,
                beginnerActionState: actionState,
            },
        }),
    },
})
